import React, { useEffect, useState } from "react";
import { Button, Col, DatePicker, Form, Modal, Row, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { getProviderListCode } from "../../../../store/SendMessageSlice";
import SVGIcon from "../../../../utils/SVGIcon";
import weekOfYear from "dayjs/plugin/weekOfYear";
import dayjs, { Dayjs } from "dayjs";
import { addPortingReport } from "../../../../store/PortingReportsSlice";
import { CONSTANT } from "../../../../config/Constant";
import { getProviderListByCodes } from "../../../../store/ProviderSlice";

const AddReport: React.FC<any> = (props) => {
  const { handleAddModal, openAddModal, getList } = props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState<boolean>(false);
  const [typeAction, setTypeAction] = useState<string>("daily");
  const [providerListCode, setProviderListCode] = useState<any>();
  const [providerListByCodes, setProviderListByCodes] = useState<any>();
  const [monthReq, setMonthReq] = useState(false);

  const updateProviderListCode = () => {
    dispatch(getProviderListCode())
      .then((res: any) => {
        const listOfProviders = res?.data
          .filter((item) => item?.id)
          .reduce((acc, current) => {
            const x = acc.find((item) => item.id === current.id);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);
        listOfProviders && setProviderListCode(listOfProviders);
      })
      .catch((error: any) => {
        setProviderListCode([]);
      });
  };

  const getProvidersByCodes = async () => {
    dispatch(getProviderListByCodes())
      .then((res: any) => {
        const listOfProvidersByCodes = res?.data
          .filter((item) => item?.id)
          .reduce((acc, current) => {
            const x = acc.find((item) => item.id === current.id);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);
        listOfProvidersByCodes &&
          setProviderListByCodes(listOfProvidersByCodes);
      })
      .catch((error: any) => {
        setProviderListByCodes([]);
      });
  };

  useEffect(() => {
    getProvidersByCodes();
    // eslint-disable-next-line
  }, []);

  const handleSubmit = (data) => {
    setLoading(true);
    let report_year;
    let report_month;
    let report_date;
    let week_number;
    if (data?.month) {
      report_month = dayjs(data?.month).format("M");
    }
    if (data?.week_number) {
      dayjs.extend(weekOfYear);
      week_number = dayjs(data?.week_number).week();
    }
    if (data?.report_year) {
      report_year = dayjs(data?.report_year).format("YYYY");
    }
    if (data?.type === "daily") {
      report_date = data?.report_date
        ? dayjs(data?.report_date).format("YYYY-MM-DD")
        : dayjs(new Date()).format("YYYY-MM-DD");
    }

    const payload = {
      type: data?.type,
      provider: data?.provider ?? "",
      report_date: report_date ?? "",
      month: report_month ?? "",
      week_number: week_number ?? "",
      report_year: report_year ?? "",
      provider_code: data.provider_code.toLowerCase(),
    };

    dispatch(addPortingReport(payload))
      .then((res: any) => {
        handleAddModal();
        getList();
      })
      .catch((error: any) => {
        console.log("error", error);

        // handleAddModal();
        // getList();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  const disabledDate = (current: Dayjs) => {
    // Can not select days after today
    return current && current.isAfter(dayjs().endOf("day"));
  };

  const disabledDateForYear = (current: Dayjs) => {
    // Disable years before 2022 and years after the current year
    const currentYear = dayjs().year();
    return current && (current.year() < 2022 || current.year() > currentYear);
  };

  const disabledDateForMonth = (current: Dayjs | null) => {
    // Disable months before January 2022 and months after the current month in the current year
    const currentYear = dayjs().year();
    const currentMonth = dayjs().month();
    if (!current) return false;
    if (current.year() < 2022) return true;
    if (current.year() === 2022 && current.month() < 0) return true; // Adjust month condition if needed
    if (current.year() > currentYear) return true;
    if (current.year() === currentYear && current.month() > currentMonth)
      return true;
    return false;
  };

  const disabledDateForWeek = (current: Dayjs | null) => {
    // Disable weeks before the first week of 2022 and weeks after the current week in the current year
    const currentYear = dayjs().year();
    const currentWeek = dayjs().week();
    if (!current) return false;
    if (current.year() < 2022) return true;
    if (current.year() > currentYear) return true;
    if (current.year() === currentYear && current.week() > currentWeek)
      return true;
    return false;
  };

  return (
    <Modal
      open={openAddModal}
      destroyOnClose
      width={900}
      onCancel={handleAddModal}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      footer={false}
      className="addModal"
      title={`Add Porting Report`}
    >
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
      >
        <Row gutter={20} align={"middle"}>
          <Col xs={12}>
            <InputBox.Radio
              type="button"
              label="Type"
              name={"type"}
              size="large"
              initialValue={typeAction}
              options={{
                list: [
                  { label: "Daily", value: "daily" },
                  { label: "Weekly", value: "weekly" },
                  { label: "Monthly", value: "monthly" },
                ],
                valueKey: "value",
                textKey: "label",
              }}
              onChange={(e: any) => {
                setTypeAction(e.target.value);
                if (
                  e.target.value === "monthly" &&
                  form.getFieldValue("provider")
                ) {
                  setMonthReq(true);
                  form.setFields([
                    {
                      name: "month",
                      errors: ["Please Select Month"],
                    },
                  ]);
                }
              }}
            />
          </Col>
          <Col xs={12} xl={8}>
            <InputBox.Select
              label="To Provider"
              name={"provider_code"}
              allowClear
              showSearch
              placeholder="Select To Provider"
              tooltip="Select To Provider"
              options={{
                list:
                  providerListByCodes?.length > 0 ? providerListByCodes : [],
                valueKey: "id",
                textKey: "provider_code",
              }}
              notFoundContent={
                providerListByCodes?.length > 0 ? null : <Spin />
              }
              required={true}
              rules={[
                { required: true, message: "Please Select To Provider." },
              ]}
              // rules={[validations.required.text('Provider')]}
            />
          </Col>
          {typeAction === "daily" ? (
            <Col xs={24} md={8}>
              <InputBox.DatePicker
                required
                label="Select Date"
                name={"report_date"}
                placeholder={"Select Date"}
                format={CONSTANT.POST_DATE_FORMAT}
                disabledDate={disabledDate}
                defaultValue={dayjs(new Date())}
                initialValue={dayjs(new Date())}
                onChange={handleChange}
                rules={[{ required: true, message: "Please Select Date." }]}
              />
            </Col>
          ) : null}
          {typeAction === "weekly" || typeAction === "monthly" ? (
            <Col xs={24} md={8}>
              <InputBox.DatePicker
                required
                label="Select Year"
                name={"report_year"}
                rules={[{ required: true, message: "Please Select Year." }]}
                disabledDate={disabledDateForYear}
                onChange={handleChange}
                format={"YYYY"}
                picker="year"
              />
            </Col>
          ) : null}

          {typeAction === "monthly" ? (
            <Col xs={24} md={8}>
              <InputBox.DatePicker
                required={monthReq ? true : false}
                label="Select Month"
                name="month"
                rules={
                  monthReq
                    ? [{ required: true, message: "Please Select Month" }]
                    : [{ required: false }]
                }
                format={"YYYY-MM"}
                disabledDate={disabledDateForMonth}
                onChange={handleChange}
                picker="month"
              />
            </Col>
          ) : null}
          {typeAction === "weekly" ? (
            <Col xs={24} md={8}>
              <Form.Item label="Select Week" name={"week_number"}>
                <DatePicker
                  placeholder={"Select Week"}
                  picker="week"
                  disabledDate={disabledDateForWeek}
                />
              </Form.Item>
            </Col>
          ) : null}
          <Col xs={24} md={8}>
            <InputBox.Select
              label="Provider Code"
              name={"provider"}
              allowClear
              showSearch
              placeholder="Select Provider Code"
              tooltip="Select on from provided network provider list"
              onFocus={() =>
                providerListCode?.length > 0 ? null : updateProviderListCode()
              }
              notFoundContent={providerListCode?.length > 0 ? null : <Spin />}
              options={{
                list: providerListCode && providerListCode,
                valueKey: "id",
                textKey: "provider_code",
              }}
              onSelect={() => {
                if (typeAction === "monthly") {
                  setMonthReq(true);
                  handleChange();
                }
              }}
              onClear={() => {
                if (typeAction === "monthly") {
                  setMonthReq(false);
                  handleChange();
                }
              }}
              // required
              // rules={[validations.required.text('Provider')]}
            />
          </Col>
        </Row>
        <Row gutter={[20, 20]} className="mt-20">
          <Col xs={12} md={12} lg={6}>
            <Button type="primary" htmlType="submit" loading={loading}>
              <SVGIcon icon="add" color="#fff" width={55} /> Add Report
            </Button>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                if (typeAction === "daily") {
                  form.setFieldsValue({ report_date: dayjs(new Date()) });
                }
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </Modal>
  );
};

export default AddReport;
